import React, { useState } from "react";
import CustomTable from "../../components/CustomTable";
import SearchAndFilterBar from "../../components/SearchAndFilterBar";

const EditHistory = () => {
  // Initial Data
  const initialData = Array.from({ length: 60 }, (_, index) => ({
    id: index + 1,
    madv: `#DV000${(index + 1).toString().padStart(2, "0")}`,
    serviceName: "Tên dịch vụ",
    account: "Đỗ Thị Thu Trang",
    creationDate: "12/11/2024 | 08:53",
    lastEditDate: "12/11/2024 | 08:53",
    content: [
      "Cập nhật trạng thái nộp đơn",
      "Cập nhật trạng thái bổ sung chứng từ",
      "Sửa thông tin họ tên khách hàng",
      "Cập nhật hình thức anh toán",
      "Xuất file thông tin dịch vụ",
    ][index % 5], // cycling through content options
    serviceInfo: {
      serviceName: "Tên dịch vụ",
      serviceImage: "/images/logo.png",
    },
  }));

  // State
  const [searchFilters, setSearchFilters] = useState({
    search_value: "",
    from_date: "",
    to_date: "",
  });
  const [filteredData, setFilteredData] = useState(initialData);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(30);

  // Handle Search
  const handleSearch = () => {
    const result = initialData.filter((item) => {
      const matchesSearch =
        item.madv
          .toLowerCase()
          .includes(searchFilters.search_value.toLowerCase()) ||
        item.serviceName
          .toLowerCase()
          .includes(searchFilters.search_value.toLowerCase());

      const withinDateRange = () => {
        const itemDate = new Date(
          item.creationDate.split(" | ")[0].split("/").reverse().join("-")
        );
        const fromDate = searchFilters.from_date
          ? new Date(searchFilters.from_date)
          : null;
        const toDate = searchFilters.to_date
          ? new Date(searchFilters.to_date)
          : null;

        if (fromDate && itemDate < fromDate) return false;
        if (toDate && itemDate > toDate) return false;
        return true;
      };
      return matchesSearch && withinDateRange();
    });

    setFilteredData(result);
  };

  // Columns for CustomTable
  const columns = [
    { key: "id", title: "STT", align: "text-center" },
    {
      key: "madv",
      title: "MÃ DỊCH VỤ",
      render: (value) => (
        <div className="text-[#0267FF] min-w-[50px]">{value}</div>
      ),
    },
    {
      key: "serviceInfo",
      title: "DỊCH VỤ",
      render: (value) => (
        <div className="flex items-center space-x-2 min-w-[200px]">
          <img
            src={value.serviceImage}
            alt="Service Logo"
            className="w-[32px] h-[32px] rounded-lg object-contain"
          />
          <p className="text-gray-500 text-sm">{value.serviceName}</p>
        </div>
      ),
    },
    {
      key: "account",
      title: "TÀI KHOẢN",
      render: (value) => <div className="whitespace-nowrap">{value}</div>,
    },
    {
      key: "creationDate",
      title: "NGÀY TẠO",
      render: (value) => <div className="whitespace-nowrap">{value}</div>,
    },
    {
      key: "lastEditDate",
      title: "THỜI GIAN CHỈNH SỬA",
      render: (value) => <div className="whitespace-nowrap">{value}</div>,
    },
    {
      key: "content",
      title: "NỘI DUNG",
      render: (value) => <div className="min-w-[250px]">{value}</div>,
    },
  ];

  return (
    <div className="py-6">
      {/* Search and Filter */}
      <SearchAndFilterBar
        searchPlaceholder="Tìm kiếm dịch vụ"
        searchValue={searchFilters.search_value}
        onSearchChange={(e) =>
          setSearchFilters({ ...searchFilters, search_value: e.target.value })
        }
        showDatePickers
        fromDatePlaceholder="Từ ngày"
        toDatePlaceholder="Đến ngày"
        onFromDateChange={(date) =>
          setSearchFilters({ ...searchFilters, from_date: date })
        }
        onToDateChange={(date) =>
          setSearchFilters({ ...searchFilters, to_date: date })
        }
        onAddClick={handleSearch}
        addButtonLabel="Tìm kiếm"
        addButtonIcon="/icons/search.svg"
      />

      {/* Custom Table */}
      <CustomTable
        data={filteredData}
        columns={columns}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        setView
        basePath="/quan-ly-khach-hang/khach-hang"
      />
    </div>
  );
};

export default EditHistory;
